import React, { FC, useEffect, useState } from "react";
import { DatePicker, DatePickerProps } from "antd";
import { Maybe } from "graphql/jsutils/Maybe";
import { Core_LocalDateMsg } from "../../../../src/generated/graphql";
import { Moment } from "moment";
import {
  localDateToMoment,
  momentToLocalDate,
} from "../../../../helpers/utils";

interface LocalDateInputProps {
  value: Maybe<Core_LocalDateMsg> | undefined;
  onChange: (value: Maybe<Core_LocalDateMsg> | undefined) => void;
}

export const LocalDateInput: FC<LocalDateInputProps> = ({
  value,
  onChange,
}) => {
  const [internalValue, setInternalValue] = useState<
    Maybe<Moment> | undefined
  >();

  useEffect(() => {
    const momentOfLocalDate = localDateToMoment(value);
    if (!momentOfLocalDate?.isSame(internalValue, "date")) {
      setInternalValue(momentOfLocalDate);
    }
  }, [value]);

  const onDateChange: DatePickerProps["onChange"] = (date) => {
    setInternalValue(date);

    onChange(momentToLocalDate(date));
  };

  return (
    <div>
      <DatePicker
        size={"large"}
        style={{ width: "100%" }}
        format={['DD.MM.YYYY', 'DDMMYYYY']}
        showTime={false}
        value={internalValue}
        onChange={onDateChange}
      />
    </div>
  );
};
